import { Injectable } from '@angular/core';
import { Formatter } from '../../../comum/pipes/formatter';
import {Fornecedores} from '../../../models/fornecedores.model'
import { UsersService } from '../../../models/usuarios.service';
import { CarrinhoItemsModel } from '../../../models/carrinhoItems.model';
import { QueryFn } from '../../../node_modules/angularfire2/firestore';

@Injectable()
export class PrinterService{

  private nomeFornecedor : string = ''
  private cnpjFornecedor : string = ''
  constructor(private usersSrc : UsersService){  
  }
  
  printNewWindow(content : string){
    try
    {
      let win : Window = window.open()
      if(!win) { 
        throw new Error('libere o filtro de de pop-ups para abrir a janela de impressão.')
      }  
      win.document.write(content)
      win.print()
      win.close()
    }
    catch(Err){
      alert(Err.message || JSON.stringify(Err))
    }
  }

  printPedido( pedido : any[] ){
    if(!(pedido && (pedido.length > 0)))
      return 

    console.log(JSON.stringify(pedido))  
    this.getFornecedor(pedido[0].fornecedor,
      (data)=>{ 
      this.nomeFornecedor = data[0].nome
      this.cnpjFornecedor = data[0].cnpj  
      let global_styles = `
        <style>
            @page {
              size: A4;
              margin: 0;
          }
          @media print {
              .page {
                  margin: 0;
                  border: initial;
                  border-radius: initial;
                  width: initial;
                  min-height: initial;
                  box-shadow: initial;
                  background: initial;
                  page-break-after: always;
              }
          }

          .center {
            display : flex; 
            flex-direction: column; 
            justify-content: flex-center; 
            align-items:center;
          }
          .font{
            font-size : 0.8em;
          } 
          .hr{
            border: 0.7px solid black;  width: 100%;
          }
          .line{
            display : flex; 
            flex-direction: row; 
            justify-content: space-around; 
            width:100%;
          }
          .cell{
            display : flex; 
            flex-direction: row; 
            justify-content: flex-start; 
          }
          .footer{
            display : flex; 
            flex-direction: column; 
            justify-content: flex-start; 
            width:100%;
          }
          .right {
            display : flex; 
            flex-direction: row; 
            justify-content: flex-end; 
            width:100%;
            margin-right:20px;
          }

        </style> `
  
        let getTelefone = ()=>  pedido[0].cliente.fone || pedido[0].cliente.fone +'-'+pedido[0].entrega.fone           
        
        let template = `<br/><br/><div class="center page">
        <div> <b>PEDIDO ${pedido[0].pedido} </b> </div>
        <div class="center" style="text-align:center;"> 
        <b>Controle Interno</b></div>
        <br>
        <div class="line"><div> <b> Loja :</b> <label>${this.nomeFornecedor}</label> </div>
        </div>
        <hr class="hr">
        <div> <b> Identificação do destinatário </b> </div>
        <hr class="hr"> 
        <div class="line"><div> <b> Nome :</b> <label>${ pedido[0].cliente.nome}</label> </div>
        
        <div><b>CNPJ/CPF:</b><label>${ pedido[0].cliente.cpf }</label></div> </div>
        <hr class="hr"> 
        <div class="line">
        <div> <b> Data :</b> <label>${new Date(pedido[0].data).toLocaleDateString()}</label> </div>
        <div> <b> e-mail :</b> <label>${pedido[0].cliente.email}</label> </div>
        <div> <b> Fone :</b> <label>${getTelefone()}</label> </div>

        <div> <b> Contato :</b> <label>${pedido[0].cliente.nome}</label> </div>
        </div>
        <hr class="hr"> 
        ${(()=>{
          let result = `<div class="line" style="margin-left:5px;"> <div  class="cell" style="width:20%;"> <b> Código </b> </div> 
          <div  class="cell" style="width:30%;"> <b> Descrição </b>  </div>
          <div  class="cell" style="width:10%;"> <b> Un.</b>  </div>
          <div  class="cell" style="width:10%;"> <b> Quant.</b> </div>
          <div  class="cell" style="width:10%;"> <b> V.Unit.</b> </div>
          <div  class="cell" style="width:20%;"> <b> V.Total</b> </div>
          </div>`
          for(let item of pedido){
            result += 
            `<div class="line" style="margin-left:5px;"> 
            <div class="cell" style="width:20%;"> <label> ${item.produto} </label> </div> 
            <div class="cell" style="width:30%;"> <label> ${item.nome} </label>  </div>
            <div class="cell" style="width:10%;"> <label> ${item.unidade}</label>  </div>
            <div class="cell" style="width:10%;"> <label> ${CarrinhoItemsModel.formatQtde(item.qtde)}</label> </div>
            <div class="cell" style="width:10%;"> <label> ${Formatter.formatMoney(item.precoVenda)}</label> </div>
            <div class="cell" style="width:20%;"> <label> ${Formatter.formatMoney(item.total || item.valor)}</label> </div>
            </div>` 
          }
          return result
        })()} 
        <hr class="hr"> 
        <div class="right"> <div> <b>Total : </b> <label>
        ${(()=>{   
           let sum = 0 
           for(let elem of pedido)
              sum += elem.total || elem.valor 
           return Formatter.formatMoney(sum) })()}</label> </div> </div>
        <hr class="hr"> 
        <div class="footer">
        <div><b>Observação : ${ pedido[0].entrega.obs||'' }</b> </div>
        <div><b>Endereço de entrega : </b><label>${ pedido[0].entrega.endereco+(()=> {let r = pedido[0].entrega.numero || ''; return `${r ? ','+String(r) : ''}`})()+' , '+pedido[0].entrega.bairro+' , '+pedido[0].entrega.cidade+' - '+pedido[0].entrega.estado+' CEP: '+pedido[0].entrega.cep  } </label> </div>
        <div><b>Complemento : </b> <label>${ pedido[0].entrega.complemento || '' }</label></div>
        <div><b>Referência : </b> <label>${ pedido[0].entrega.refer || '' }</label></div>
        </div>
        <hr class="hr"> 
        <div class="footer">
        <div><b>Condição de pagamento : </b> </div>
             ${pedido[0].formPagamento.parcelas+' x '+pedido[0].formPagamento.nome}
        </div>
        <hr class="hr"> 
        </div>` 
        
          this.printNewWindow(global_styles+template)
     }) 
      }


      private getFornecedor(nFornecedor,callback : Function){
        const fornecedorModel = new Fornecedores(this.usersSrc.usuarioClass.dbConn,true)
        let where : QueryFn = 
        (elem) =>  {
          return elem.where('codigo','==',nFornecedor)
          .limit(1)
        }
       
          fornecedorModel.snapshot(where,(data)=>{
            if(data && (data.length > 0))
              callback(data)
          },false)
      }
}
